import { MainContainer } from "../components/MainContainer";
import { useState, useEffect, useContext } from "react";
import { sampleDepartments, sampleLocations } from "../../../data/jobs";
import { SectionHeader } from "../components/SectionHeader";
import { JobCard } from "../components/JobCard";
import { HeroHeader } from "../components/HeroHeader";
import { Store } from "../../../context/store";
import { apiHandler } from "../../../service/apiHelper";
import { Vacancies, Vacancy } from "../models/Vacancies";
import { RaceBy } from "@uiball/loaders";

export const HomePage = () => {
  const store = useContext(Store);
  const headers = {
    "x-api-key": store.apiKey,
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [allVacancies, setAllVacancies] = useState<Vacancy[]>([]);

  const [selectedDepartment, setSelectedDepartments] = useState(
    sampleDepartments[0]
  );

  const [selectedLocation, setSelectedLocation] = useState(sampleLocations[0]);
  const [searchValue, setSearchValue] = useState("");

  const filteredList = allVacancies;

  const getVacancies = async () => {
    const api = await apiHandler({
      url: `${store.baseUrl}/${store.code}/jobs?page=${currentPage}&pagesize=10`,
      method: "GET",
      headers: headers,
    });

    if (api.success) {
      let response = api.data as Vacancies;

      if (response.totalPages > currentPage) {
        setCurrentPage(currentPage + 1);
      }
      const newVacancies: Vacancy[] = response.data
        .filter((item) => !item.isClosed)
        .map((vacancy) => vacancy);
      setAllVacancies(newVacancies);
    } else {
    }
  };

  useEffect(() => {
    getVacancies();
  }, []);

  return (
    <MainContainer>
      <HeroHeader copy={store.company?.heroMessage ?? ""} />
      <div className="px-4 md:px-8">
        <SectionHeader
          departmentChange={setSelectedDepartments}
          locationChange={setSelectedLocation}
          departments={sampleDepartments}
          locations={sampleLocations}
          setQuery={setSearchValue}
          selectedDepartment={selectedDepartment}
          selectedLocation={selectedLocation}
        />

        {allVacancies ? (
          <>
            {filteredList.length > 0 ? (
              <>
                <ul className="grid gap-6 my-6 md:grid-cols-2">
                  {(searchValue === ""
                    ? filteredList
                    : filteredList.filter((job) =>
                        job.title
                          .toLowerCase()
                          .includes(searchValue.toLowerCase())
                      )
                  )
                    .sort((a, b) => (a.datePosted > b.datePosted ? 1 : -1))
                    .map((job) => (
                      <li key={job.id}>
                        <JobCard job={job} />
                      </li>
                    ))}
                </ul>
              </>
            ) : (
              <p className="w-full py-10 my-3 text-base font-medium text-center text-gray-700 rounded-lg bg-primary-50">
                No Open Positions found
              </p>
            )}
          </>
        ) : (
          <div className="grid w-full my-12 place-items-center">
            <p className="pb-4 text-sm text-gray-500">
              Getting Open Positions...
            </p>
            <RaceBy size={120} lineWeight={5} speed={1.4} color="#3F52E3" />
          </div>
        )}
      </div>
    </MainContainer>
  );
};
